import {palette} from '@/Themes/Mistubishi/palette.js';
import {theme_air_air, theme_air_water, theme_cta} from '@/Themes/Mistubishi/theme.js';

export const DEFAULT_CHANGELOG_THEME = 'air_water';

// Thèmes de couleur proposés pour l'encart de titre et le contour d'une entrée de
// changelog (page Nouveautés, modale de première connexion, aperçu du formulaire).
export const CHANGELOG_THEMES = {
    air_air: {label: 'Air/Air', theme: theme_air_air, color: palette.air_air.main},
    air_water: {label: 'Air/Eau', theme: theme_air_water, color: palette.air_water.main},
    cta: {label: 'CTA', theme: theme_cta, color: palette.cta.main},
};

export const CHANGELOG_THEME_KEYS = Object.keys(CHANGELOG_THEMES);

export const changelogTheme = (key) => (CHANGELOG_THEMES[key] ?? CHANGELOG_THEMES[DEFAULT_CHANGELOG_THEME]).theme;

export const changelogThemeColor = (key) => (CHANGELOG_THEMES[key] ?? CHANGELOG_THEMES[DEFAULT_CHANGELOG_THEME]).color;

// Habillage commun : contour coloré et encart de titre à cheval sur le bord supérieur.
// La couleur vient du thème fourni par le ThemeProvider appelant.
export const TITLE_BLOCK_HEIGHT = 30;

export const outlinedBoxStyle = (theme) => ({
    position: 'relative',
    overflow: 'visible',
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: `${theme.shape.borderRadius}px`,
});

export const titleBlockStyle = (theme) => ({
    position: 'absolute',
    top: -(TITLE_BLOCK_HEIGHT / 2 + 2),
    left: -2,
    height: TITLE_BLOCK_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    pl: 2,
    pr: 1,
    borderRadius: 3,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    outline: '.6rem solid white',
    textAlign: 'center',
});

export const titleTextStyle = {
    paddingTop: '2px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
};

export const titleIconStyle = {
    marginLeft: '.5rem',
    fontSize: '.6rem',
};

export const changelogCardTitle = (changelog) =>
    (changelog?.version ? `${changelog.title} (v${changelog.version})` : (changelog?.title ?? '')).toUpperCase();
